import { toast } from 'sonner';
import i18n from './i18n';

const TOAST_ID = 'backend-reconnecting';

let shown = false;

/**
 * A calm notice for the seconds during which the API is unreachable -- normally
 * a deploy swapping the container.
 *
 * Shown from the retry predicate rather than from QueryCache.onError, because
 * onError is a GIVE-UP callback: it only fires once every retry is exhausted
 * (~11.5s). Wiring the notice there meant it could never appear during the 2-4s
 * outage it exists for, and when it did appear it claimed "Reconnecting…" at
 * the exact moment retrying had stopped.
 *
 * Idempotent -- sonner dedupes by id, so ten failing queries produce one toast.
 */
export function showReconnecting(): void {
  if (shown) return;
  shown = true;
  toast.loading(i18n.t('toast.reconnecting', 'Reconnecting…'), {
    id: TOAST_ID,
    duration: Infinity,
  });
}

export function hideReconnecting(): void {
  if (!shown) return;
  shown = false;
  toast.dismiss(TOAST_ID);
}
